module.exports = {
    tag: 'eagle',
    quality: 0.3,
    perception: 3
};